module.exports = __webpack_public_path__ + "img/圆形矩阵工艺.29bddb0d.jpg";